import { MARQUEE_ITEMS } from "../lib/constants";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="marquee-strip"
      className="relative overflow-hidden bg-brand-surfaceAlt/50 border-y border-brand-line/60 py-8"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {items.map((t, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span className="font-serif italic text-2xl md:text-3xl text-brand-moss mx-10">{t}</span>
            <span className="w-1.5 h-1.5 rounded-full bg-brand-terracotta" />
          </div>
        ))}
      </div>
    </div>
  );
}
